import { UrlDescriptor } from '@shared/abstract/url-descriptor.interface';


export class SkipDescriptor implements UrlDescriptor {
  constructor(private value: number) {}

  serialize = () => `${this.value}`;
}
